import classNames from 'classnames';
import React, { PureComponent } from 'react';
import { BaseInputProps } from '../types';
import { isNullLike } from '../utils';
import { Radio } from 'antd';

export interface BoolProps extends BaseInputProps {
  value?: boolean;

  onChange?(val?: boolean): void;
}

export class Bool extends PureComponent<BoolProps> {
  options = [
    { label: 'TRUE', value: true },
    { label: 'FALSE', value: false },
  ];

  onChange = (val: boolean) => {
    this.props.onChange?.(val);
    this.props.onBlur?.();
  };

  render() {
    return (
      <div
        className={classNames(
          { readonly: this.props.readonly },
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? (
          <span>
            {!isNullLike(this.props.value) ? String(this.props.value).toUpperCase() : 'N/A'}
          </span>
        ) : (
          <Radio.Group
            block
            options={this.options}
            value={this.props.value}
            onChange={(e) => this.onChange(e.target.value)}
            className='w-40'
          />
        )}
      </div>
    );
  }
}
